import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "body-1 px-2",
  style: {"color":"red","text-align":"justify"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_BudgetDiagram = _resolveComponent("BudgetDiagram")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_FullBudgetProcess = _resolveComponent("FullBudgetProcess")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_BudgetFormAccountableAccount = _resolveComponent("BudgetFormAccountableAccount")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "pb-2 mr-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "pb-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_primary, {
                      onClick: _ctx.newBudgetProcess,
                      block: "",
                      id: "Senario"
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("Ajouter")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "pl-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_menu, null, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_text_field, _mergeProps({
                          outlined: "",
                          "hide-details": true
                        }, props, {
                          readonly: "",
                          "append-inner-icon": 'arrow_drop_down',
                          "model-value": 
                                    _ctx.selected != -1
                                        ? _ctx.scenariosSelection[_ctx.selected].name
                                        : 'Pas de scénario'
                                ,
                          density: "compact"
                        }), null, 16, ["model-value"])
                      ]),
                      default: _withCtx(() => [
                        (_ctx.scenariosSelection && _ctx.scenariosSelection.length)
                          ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenariosSelection, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: index,
                                    onClick: ($event: any) => {
                                    _ctx.id = item.id;
                                    _ctx.selected = index;
                                }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "pl-2",
                  id: "Year"
                }, {
                  default: _withCtx(() => [
                    (_ctx.id)
                      ? (_openBlock(), _createBlock(_component_v_select, {
                          key: 0,
                          modelValue: _ctx.selectedPeriod,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPeriod) = $event)),
                          items: _ctx.periodsList,
                          "item-value": "id",
                          outlined: "",
                          "single-line": "",
                          "hide-details": "",
                          label: "Exercice",
                          density: "compact",
                          "item-title": (item) => item.name
                        }, null, 8, ["modelValue", "items", "item-title"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (!_ctx.$vuetify.display.mobile)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TutorialButtonDialog, { starterComponents: 'Budgets;' })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  class: "d-flex justify-end align-center",
                  id: "Help"
                }, {
                  default: _withCtx(() => [
                    (_ctx.isFormEditable)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$oss-edit" }, props, {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editBudgetForm()))
                            }), null, 16)
                          ]),
                          default: _withCtx(() => [
                            _cache[10] || (_cache[10] = _createElementVNode("span", null, "Editer", -1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.enableDuplicate)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 1,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$oss-duplicate" }, props, {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyBudgetForm()))
                            }), null, 16)
                          ]),
                          default: _withCtx(() => [
                            _cache[11] || (_cache[11] = _createElementVNode("span", null, "Dupliquer", -1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.selected != -1)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 2,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_trash, _mergeProps(props, {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteBudgetDialog = true))
                            }), null, 16)
                          ]),
                          default: _withCtx(() => [
                            _cache[12] || (_cache[12] = _createElementVNode("span", null, "Supprimer", -1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.id)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 3,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$oss-download" }, props, {
                              onClick: _ctx.downloadExcel,
                              disabled: _ctx.downloadDisabled
                            }), null, 16, ["onClick", "disabled"])
                          ]),
                          default: _withCtx(() => [
                            _cache[13] || (_cache[13] = _createElementVNode("span", null, "Télécharger", -1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "pb-2 mr-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    (_ctx.id)
                      ? (_openBlock(), _createBlock(_component_BudgetDiagram, {
                          key: 0,
                          budgetId: _ctx.id,
                          companyId: _ctx.selectedCompany.id,
                          startDate: _ctx.scenariosSelection[_ctx.selected].date,
                          selectedPeriod: _ctx.selectedPeriod,
                          refreshData: _ctx.refreshData,
                          onGetPeriodsList: _ctx.onPeriodsListChanged,
                          onIsDownloadable: _ctx.isDownloadable
                        }, null, 8, ["budgetId", "companyId", "startDate", "selectedPeriod", "refreshData", "onGetPeriodsList", "onIsDownloadable"]))
                      : (_ctx.loading)
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 1,
                            elevation: "0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, {
                                style: {"text-align":"center"},
                                class: "pa-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_progress_circular, {
                                    size: 70,
                                    width: 7,
                                    color: "primary",
                                    indeterminate: "",
                                    style: {"margin":"24px"}
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (!_ctx.scenariosSelection.length)
                          ? (_openBlock(), _createBlock(_component_v_card, {
                              key: 2,
                              class: "default_card large",
                              elevation: "0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, {
                                  style: {"text-align":"center !important"},
                                  "primary-title": ""
                                }, {
                                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                                    _createTextVNode(" Créer votre premier budget prévisionnel ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_card_text, { style: {"text-align":"center"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      class: "btn_card",
                                      rounded: "",
                                      onClick: _ctx.newBudgetProcess,
                                      elevation: "0",
                                      id: "Ajouter",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { style: {"margin-right":"3px"} }, {
                                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                                            _createTextVNode(" $assessment ")
                                          ])),
                                          _: 1
                                        }),
                                        _cache[16] || (_cache[16] = _createTextVNode("Ajoutez votre premier scénario"))
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.showBudgetProcess)
              ? (_openBlock(), _createBlock(_component_FullBudgetProcess, {
                  key: 0,
                  modelValue: _ctx.showBudgetProcess,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showBudgetProcess) = $event)),
                  budgetId: _ctx.budgetToEdit,
                  budgetIdToCopy: _ctx.budgetToCopy,
                  onBudgetCreated: _ctx.onBudgetCreated,
                  onBudgetModified: _ctx.onBudgetModified
                }, null, 8, ["modelValue", "budgetId", "budgetIdToCopy", "onBudgetCreated", "onBudgetModified"]))
              : _createCommentVNode("", true),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.displayBudgetModeSelector,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.displayBudgetModeSelector) = $event)),
              title: "Sélectionner la méthode d'initialisation de votre budget",
              "min-height": "90vh",
              onValid: _ctx.openSelectedBudgetMode,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createElementVNode("div", { class: "body-1" }, " Souhaitez-vous initialiser votre budget à partir de votre dernier exercice enregistré ? ", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _cache[18] || (_cache[18] = _createElementVNode("div", {
                          class: "body-1 px-2",
                          style: {"text-align":"justify"}
                        }, " Cette méthode permet de récupérer les comptes comptables de votre exercice précédent et de sélectionner les champs que vous souhaitez reporter dans votre prochain budget. Vous pourrez choisir de reporter un pourcentage de ces montants si vous le souhaitez. ", -1)),
                        _cache[19] || (_cache[19] = _createElementVNode("div", {
                          class: "body-1 px-2",
                          style: {"text-align":"justify"}
                        }, " Cette méthode est recommandée pour réaliser un budget précis de l'exercice à venir. ", -1)),
                        _cache[20] || (_cache[20] = _createElementVNode("div", {
                          class: "body-1 px-2",
                          style: {"text-align":"justify"}
                        }, " Attention : vous devez disposer de données pour l'exercice précédent pour l'appliquer. ", -1)),
                        (!_ctx.selectedAccountingPeriod)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Veuillez sélectionner un exercice comptable pour appliquer cette méthode. "))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createElementVNode("div", {
                          class: "body-1 px-2",
                          style: {"text-align":"justify"}
                        }, " Si vous passez cette étape, vous commencerez avec un budget vierge. ", -1),
                        _createElementVNode("div", {
                          class: "body-1 px-2",
                          style: {"text-align":"justify"}
                        }, " Ce cas de figure est recommandé pour la création d'un budget de démarrage à moyen ou long terme, ou si vous ne disposez pas encore de données pour l'exercice précédent. ", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_col, {
                      cols: "10",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          modelValue: _ctx.budgetMode,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.budgetMode) = $event)),
                          items: _ctx.budgetModes,
                          "item-value": "id",
                          outlined: "",
                          "single-line": "",
                          "hide-details": "",
                          label: "Méthode d'initialisation",
                          density: "compact",
                          "item-title": (item) => item.name
                        }, null, 8, ["modelValue", "items", "item-title"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onValid"]),
            (_ctx.showFormNM1)
              ? (_openBlock(), _createBlock(_component_BudgetFormAccountableAccount, {
                  key: 1,
                  modelValue: _ctx.showFormNM1,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showFormNM1) = $event)),
                  id: _ctx.selectedBfaaId,
                  chargesGroupingMode: _ctx.chargesGroupingMode,
                  onInitializeBff: _ctx.onInitializeBff
                }, null, 8, ["modelValue", "id", "chargesGroupingMode", "onInitializeBff"]))
              : _createCommentVNode("", true),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.deleteBudgetDialog,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.deleteBudgetDialog) = $event)),
              title: 'Supprimer un scénario',
              onValid: _ctx.deleteBudget,
              width: "800px"
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [
                _createElementVNode("div", { class: "body-1" }, "Êtes-vous sur de vouloir supprimer un scénario ?", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "onValid"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}